import { formatRequest } from "../utils/function";
import axiosInstance from "./axiosInstance";


export function createStockEntry(data) {
  return axiosInstance.post(`/create-stock-entry`, formatRequest(data));
}
